<script>
// import axios from "axios";

import Layout from "@/components/pages/layouts/auth";
import { required, email } from "vuelidate/lib/validators";
import { mapState, mapActions } from 'vuex';

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Forgot Password",
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      submitted: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    ...mapActions('auth', ['forgotPassword']),
    tryToReset() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      else if (this.email) {
        this.forgotPassword(this.email)
      }
    }
  },
  computed: {
    ...mapState('notification', {
      notificationType: state => state.type,
      notificationMessage: state => state.message
    })
  }
};
</script>

<template>
  <Layout>
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">
      <div class="card overflow-hidden">
        <div class="bg-soft bg-primary">
          <div class="row">
            <div class="col-7">
              <div class="text-primary p-4">
                <h5 class="text-primary">Reset Password</h5>
              </div>
            </div>
            <div class="col-5 align-self-end">
              <img
                src="@/assets/images/profile-img.png"
                alt
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="card-body pt-0">
          <div>
            <div class="avatar-md profile-user-wid mb-4">
              <span class="avatar-title rounded-circle bg-light">
                <img src="@/assets/images/mpv-logo-small.png" alt height="32" />
              </span>
            </div>
          </div>

          <div class="p-2">
            <div v-if="notificationMessage" :class="'alert ' + notificationType">
              {{ notificationMessage }}
            </div>
            <form @submit.prevent="tryToReset">
              <div class="mb-3">
                <label for="useremail">Email</label>
                <input type="email" v-model="email" class="form-control" id="useremail" placeholder="Enter email"
                  :class="{ 'is-invalid': submitted && $v.email.$invalid, 'is-valid': submitted && !$v.email.$error }" />
                <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                  <span v-if="!$v.email.required">Email is required.</span>
                  <span v-if="!$v.email.email">Please enter valid email.</span>
                </div>
              </div>
              <div class="mb-3 row mb-0">
                <div class="col-12 text-center">
                  <button class="btn btn-primary w-md" type="submit">
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- end card-body -->
      </div>
    <!-- end card -->

      <div class="mt-5 text-center">
        <p>
          Remember It ?
          <router-link to="/login" class="fw-medium text-primary">Sign In here</router-link>
        </p>
        <p>
          © {{ new Date().getFullYear() }} My Property Vault
        </p>
      </div>
    </div>
    <!-- end col -->
  </div>
  <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
